import React from 'react';
import ScoreDisplay from '../ScoreProgressBar/ScoreDisplay';
import ScoreMetricDisplay from './ScoreMetricDisplay';
import CompetitorComparisonSection from './CompetitorComparisonSection';
import KeywordPositionSection from './KeywordPositionSection';

const GlobalScoreContent = ({ scoreData }) => {
  if (!scoreData) {
    return null;
  }

  return (
    <div className="global-score-content">
      <ScoreDisplay score={scoreData.globalScore} />
      <ScoreMetricDisplay
        seoScore={scoreData.seoScore}
        uxScore={scoreData.uxScore}
      />
      <CompetitorComparisonSection
        score={scoreData.globalScore}
        industryAverageScore={scoreData.industryAverage}
        ranking={scoreData.yourRanking}
        competitors={scoreData.competitors}
      />
      <KeywordPositionSection keywordData={scoreData.keywordTracking} />
    </div>
  );
};

export default GlobalScoreContent;
